var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.234401 0.83441C0.384423 0.684433 0.587869 0.600181 0.800001 0.600181C1.01213 0.600181 1.21558 0.684433 1.3656 0.83441L4 3.46881L6.6344 0.83441C6.7082 0.758002 6.79647 0.697056 6.89408 0.655129C6.99168 0.613202 7.09666 0.591133 7.20288 0.59021C7.3091 0.589287 7.41445 0.609528 7.51276 0.649752C7.61108 0.689977 7.7004 0.74938 7.77552 0.824494C7.85063 0.899608 7.91003 0.98893 7.95026 1.08725C7.99048 1.18556 8.01073 1.29091 8.0098 1.39713C8.00888 1.50335 7.98681 1.60833 7.94488 1.70593C7.90296 1.80354 7.84201 1.89181 7.7656 1.96561L4.5656 5.16561C4.41558 5.31559 4.21213 5.39984 4 5.39984C3.78787 5.39984 3.58442 5.31559 3.4344 5.16561L0.234401 1.96561C0.0844241 1.81559 0.000171661 1.61214 0.000171661 1.40001C0.000171661 1.18788 0.0844241 0.984432 0.234401 0.83441Z",
    fill: "#00AB4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/drop-down.05855d10c38e3a5108597ff7d3775549.svg";
export { ForwardRef as ReactComponent };